import { invoice } from "./api";
import { InvoiceData } from "../models/Entregas";
import { STATUS_PENDING_PAYMENT } from '../Constants';


export default async function getPix(ids: string): Promise<InvoiceData[]> {
    const { data } = await invoice.get(`store/${ids}/?status=${STATUS_PENDING_PAYMENT}`);
    return data.invoices;
}
